import { GLOBAL_HOME_NAV_ITEM_ID } from '../../constants/globalHome';
export const maybeMoveGlobalHomePrimaryNavItem = ({
  store
}) => {
  const globalHomeItemIndex = store.navItems.primaryNav.navItems.findIndex(navItem => navItem.id === GLOBAL_HOME_NAV_ITEM_ID);
  if (globalHomeItemIndex !== -1) {
    const globalHomeItem = store.navItems.primaryNav.navItems.splice(globalHomeItemIndex, 1);
    store.navItems.primaryNav.navItems.unshift(globalHomeItem[0]);
  }
  return store;
};